import { useTranslation } from "react-i18next"
import { IconCheckBox } from "../../../-components/icon-check-box"
import { TheasoftColumnDef } from "@/routes/-components/custom-tanstack-table"
import { UserDto } from "@/orval/gen"
import { PersonName } from "@components/PersonName"

export function useUserTableColumns() {
  const { t } = useTranslation("app_server")

  const columns = React.useMemo<TheasoftColumnDef<UserDto>[]>(
    () => [
      {
        accessorKey: "userName",
        header: t("Username"),
        cell: ({ cell, row }) =>
          row.original.userType === "UserGroup" &&
          cell.getValue<string>().indexOf("_") === 0
            ? cell.getValue<string>().substring(1)
            : cell.getValue<string>(),
      },
      {
        id: "person",
        accessorFn: (row) => row.personId,
        header: t("Person"),
        cell: ({ row }) =>
          row.original.personId && (
            <PersonName personId={row.original.personId} />
          ),
      },
      {
        accessorKey: "isInactive",
        header: t("Active"),
        cell: ({ cell }) => (
          <IconCheckBox checked={!cell.getValue<boolean>()} />
        ),
      },
      {
        accessorKey: "userType",
        header: t("UserType"),
      },
    ],
    []
  )

  return { columns }
}
